import React from 'react'

import { useAuth } from '~/modules/auth/redux/hook'

interface GuardProps {
  accessWhen?: (authData: any) => boolean
  children: React.ReactNode
  fallbackComp?: React.ReactNode
}

const Guard: React.FC<GuardProps> = ({
  accessWhen = () => false,
  children,
  fallbackComp = null,
}) => {
  const { authState } = useAuth()

  const isAllowedAccess = accessWhen(authState.data)

  if (!isAllowedAccess) return fallbackComp

  return children

  // if (STATE.IDLE) return <IDLE />
  // if (STATE.LOADING) return <LOADING />
  // if (STATE.SUCCESS) return <SUCCESS />
  // if (STATE.ERROR) return <ERROR />
}

export default Guard
